export function createFileValidator(allowedExtensions = [], allowImages = true) {
  return function isAllowedFile(file) {
    if (!file) return false;
    if (allowImages && file.type && file.type.startsWith('image/')) return true;
    const name = file.name ?? '';
    const ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
    if (!ext) return false;
    return allowedExtensions.includes(ext);
  };
}

export function generateAcceptAttribute(allowedExtensions = [], allowImages = true) {
  const parts = [];
  if (allowImages) parts.push('image/*');
  if (allowedExtensions.length > 0) {
    parts.push(allowedExtensions.map((ext) => `.${ext}`).join(','));
  }
  return parts.join(',') || '*';
}

export function generateExtensionsMessage(allowedExtensions = [], allowImages = true) {
  const parts = [];
  if (allowImages) parts.push('PNG', 'JPG');
  if (allowedExtensions.length > 0) {
    parts.push(allowedExtensions.map((ext) => ext.toUpperCase()).join(', '));
  }
  return parts.join(', ');
}

export const isGroup = (entry) =>
  entry && typeof entry === 'object' && 'title' in entry && Array.isArray(entry.items);

export function findAddMenuItemByValue(entries, value) {
  if (!Array.isArray(entries)) return null;
  for (const entry of entries) {
    if (!entry || typeof entry !== 'object') continue;
    if (isGroup(entry)) {
      const found = findAddMenuItemByValue(entry.items, value);
      if (found) return found;
      continue;
    }
    const itemValue = entry.value ?? entry.text;
    if (itemValue === value) return entry;
    if (Array.isArray(entry.items)) {
      const found = findAddMenuItemByValue(entry.items, value);
      if (found) return found;
    }
  }
  return null;
}
